module.exports = __webpack_public_path__ + "img/Pittacos_Louvre.bf9e7db7.png";